import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'; // useLocation, useNavigate,
import { get } from 'lodash';
import { makeStyles } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';

import { getSessionDetails } from '../../pages/auth/auth.actions';
import { csrfTokenHeaderName } from '../../helpers/api-helper';
import Timeout from '../timeout';

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: '2rem',
  },
  appTitle: {
    flexGrow: 1,
  },
  userDetails: {
    height: '30px',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '1rem 2rem',
  },
}));

export default function Navbar() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const csrfToken = localStorage.getItem(csrfTokenHeaderName);
  // const location = useLocation();
  // const navigate = useNavigate();

  const { sessionDetails } = useSelector((state) => state.auth);

  /* useEffect(() => {
    if (sessionDetails && sessionDetails.first_name && sessionDetails.first_name.startsWith('labeler') &&
      location.pathname !== '/pose-estimation-labeling'
    ) {
      navigate('/pose-estimation-labeling');
    }
  }, [location.pathname]); */

  useEffect(() => {
    if (csrfToken && (!sessionDetails || !get(sessionDetails, 'user_id'))) {
      dispatch(getSessionDetails());
    }
  }, []);

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" className={classes.appTitle}>
            Wolley Dashboard
          </Typography>
          <Link to="/dashboard">
            <Button color="inherit">Home</Button>
          </Link>
          {!csrfToken && (
            <Link to="/login">
              <Button color="inherit">Login</Button>
            </Link>
          )}
          {Boolean(csrfToken) && (
            <Link to="/logout">
              <Button color="inherit">Logout</Button>
            </Link>
          )}
        </Toolbar>
        <Timeout /> {/* This component is used to handle session timeout */}
      </AppBar>

      {sessionDetails && sessionDetails.username && (
        <div className={classes.userDetails}>
          <span>{'User Id:'}&nbsp;&nbsp;</span>
          <span>
            <strong>{`${get(sessionDetails, 'username')}`}</strong>
          </span>
        </div>
      )}
    </div>
  );
}
